import React from "react";
import { Checkbox as MaterialCheckbox } from "@mui/material";
import { CheckboxProps } from "./checkbox.types";
import { SelectButtonCheckIcon, SelectButtonUncheckIcon } from "./checkbox-icons";

export const Checkbox: React.FC<React.PropsWithChildren<CheckboxProps>> = ({
  id,
  checked,
  onChange,
  onBlur,
  required,
  disabled,
  fontSize = "small",
  ...rest
}) => {
  return (
    <MaterialCheckbox
      id={id}
      checkedIcon={<SelectButtonCheckIcon fontSize={fontSize} />}
      icon={<SelectButtonUncheckIcon fontSize={fontSize} />}
      checked={checked}
      onChange={onChange}
      required={required}
      disabled={disabled}
      onBlur={onBlur}
      color="primary"
      {...rest}
    />
  );
};
